var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.config.title,
            visible: _vm.dialogVisible,
            width: "540px",
            "append-to-body": true,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "mt15",
              attrs: {
                model: _vm.rules,
                rules: _vm.rule,
                "label-width": _vm.labelWidth + "px",
              },
            },
            [
              _vm.rules.status == 2
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "remark" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v("拒绝理由："),
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.rules.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.rules, "remark", $$v)
                          },
                          expression: "rules.remark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.rules.status == 1
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "invoice_type" } },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("发送方式：")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择发送方式" },
                              model: {
                                value: _vm.rules.invoice_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.rules, "invoice_type", $$v)
                                },
                                expression: "rules.invoice_type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "邮箱", value: "mail" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "快递", value: "express" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.rules.invoice_type !== "mail"
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: "collect_name" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [_vm._v("联系人：")]
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { placeholder: "请输入联系人" },
                                model: {
                                  value: _vm.rules.collect_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.rules, "collect_name", $$v)
                                  },
                                  expression: "rules.collect_name",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rules.invoice_type !== "mail"
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: "collect_tel" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [_vm._v("联系电话：")]
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { placeholder: "请输入联系电话" },
                                model: {
                                  value: _vm.rules.collect_tel,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.rules, "collect_tel", $$v)
                                  },
                                  expression: "rules.collect_tel",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: _vm.propType } },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.rules.invoice_type == "mail"
                                    ? "邮箱地址"
                                    : "邮寄地址"
                                ) + "："
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.rules.invoice_type == "mail"
                            ? _c("el-input", {
                                attrs: { placeholder: "请输入邮箱地址" },
                                model: {
                                  value: _vm.rules.invoice_mail,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.rules, "invoice_mail", $$v)
                                  },
                                  expression: "rules.invoice_mail",
                                },
                              })
                            : _c("el-input", {
                                attrs: { placeholder: "请输入邮寄地址" },
                                model: {
                                  value: _vm.rules.invoice_address,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.rules, "invoice_address", $$v)
                                  },
                                  expression: "rules.invoice_address",
                                },
                              }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("备注：")]
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.rules.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.rules, "remark", $$v)
                              },
                              expression: "rules.remark",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item", [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v("开票凭证：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "avatar" },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "upload-demo mr10 mb15",
                                attrs: {
                                  action: "##",
                                  "show-file-list": false,
                                  headers: _vm.myHeaders,
                                  "http-request": _vm.uploadServerLog,
                                },
                              },
                              [
                                _vm.imageUrl
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: { src: _vm.imageUrl },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon",
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "clew" }, [
                              _vm._v(" 支持jpg、jpeg、png "),
                              _c("br"),
                              _vm._v("建议734*1034 "),
                              _c("br"),
                              _vm._v("大小不超过2M "),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }